import { ContractsColTrendsetter } from '../ContractsColTrendsetter'
import { ContractsCol } from './ContractsCol'

export const ContractsColWrapper = () => {
  const domainName = window.location.hostname.split('.')[0]
  const isTrendsetterDomain = domainName === 'trendsetter'

  if (isTrendsetterDomain) {
    return <ContractsColTrendsetter />
  }

  return <ContractsCol />
}
